<template>
  <div class="cinema-time-wrapper">
    <!-- 日期Tab - 固定在顶部，支持横向滚动 -->
    <div class="date-tabs-container">
      <div class="date-tabs">
        <div 
          v-for="(item, index) in list" 
          :key="index"
          class="date-tab"
          :class="{ active: active === index }"
          @click="onTabChange(index)">
          {{ getTime(item.showTime) }}
        </div>
      </div>
    </div>

    <!-- 影院列表 - 可滚动区域 -->
    <div class="cinema-scroll-area">
      <div class="cinema-list">
        <div 
          v-for="(item1, index1) in currentCinemaList" 
          :key="index1" 
          class="cinema-card"
          @click="goDetail(item1)">
          
          <!-- 影院名称（完整显示） -->
          <div class="cinema-name">{{ item1.cinemaName }}</div>
          
          <!-- 地址行：地址 + 距离 -->
          <div class="cinema-info">
            <div class="cinema-addr">
              <van-icon name="location-o" size="0.9rem" color="#999" />
              <span>{{ item1.cinemaAddr }}</span>
            </div>
            <div v-if="getKm(item1.gap)" class="cinema-distance">
              {{ getKm(item1.gap) }}
            </div>
          </div>
          
          <!-- 场次信息 -->
          <div class="showtime-row">
            <van-icon name="clock-o" size="0.9rem" color="#ee0a24" />
            <div class="showtime-list">{{ formatShowtime(item1.showsDate) }}</div>
          </div>
        </div>
      </div>
      <!-- 底部提示 -->
      <div v-if="currentCinemaList.length > 0" class="finished-text">没有更多了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CinemaTimeItem",
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    currentCinemaList() {
      if (this.list.length > 0 && this.list[this.active]) {
        return this.list[this.active].filmDetailList || [];
      }
      return [];
    },
    currentFilmId() {
      if (this.list.length > 0 && this.list[this.active]) {
        return this.list[this.active].filmId;
      }
      return '';
    },
    currentShowTime() {
      if (this.list.length > 0 && this.list[this.active]) {
        return this.list[this.active].showTime;
      }
      return '';
    }
  },
  methods: {
    formatShowtime(val) {
      if (!val) return '';
      return val.replaceAll('|', '  ');
    },
    
    goDetail(item) {
      this.$router.push({
        path: "/CinemaDetail",
        query: {
          filmId: this.currentFilmId,
          name: item.cinemaName,
          address: item.cinemaAddr,
          cinemaId: item.cinemaId,
          time: this.currentShowTime,
          distance: this.getKm(item.gap), // 传递距离
        },
      });
    },
    
    getTime(str) {
      const date = this.$moment(str);
      const today = this.$moment();
      const tomorrow = this.$moment().add(1, 'day');
      
      if (date.isSame(today, 'day')) {
        return '今天';
      } else if (date.isSame(tomorrow, 'day')) {
        return '明天';
      } else {
        return date.format("M月D日");
      }
    },
    
    getKm(gap) {
      if (!gap || gap === '0.0') {
        return '';
      }
      if (gap > 1000) {
        return '>1000km';
      } else {
        return gap + 'km';
      }
    },
    
    setIndex(index) {
      this.active = index;
    },
    
    onTabChange(index) {
      this.active = index;
      this.$emit("scrollToAll", index);
    }
  },
};
</script>

<style lang='scss' scoped>
.cinema-time-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
}

/* 日期Tab容器 - 固定 */
.date-tabs-container {
  flex-shrink: 0;
  background: #fff;
  padding: 0.8rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.date-tabs {
  display: flex;
  overflow-x: auto;
  padding: 0 0.8rem;
  gap: 0.6rem;
  -webkit-overflow-scrolling: touch;
  
  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.date-tab {
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  color: #666;
  background: #f5f5f5;
  border-radius: 1rem;
  white-space: nowrap;
  transition: all 0.2s ease;
  
  &.active {
    background: linear-gradient(135deg, #ee0a24 0%, #ff6b4a 100%);
    color: #fff;
    font-weight: 500;
  }
  
  &:active {
    opacity: 0.8;
  }
}

/* 影院滚动区域 */
.cinema-scroll-area {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.8rem;
}

/* 影院列表 */
.cinema-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

/* 影院卡片 - 与 CinemaItem 保持一致 */
.cinema-card {
  background-color: #fff;
  border-radius: 0.8rem;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  
  &:active {
    background-color: #f9f9f9;
  }
}

.cinema-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin-bottom: 0.6rem;
  word-break: break-word;
}

.cinema-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  margin-bottom: 0.6rem;
}

.cinema-addr {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  font-size: 0.85rem;
  color: #999;
  line-height: 1.5;
  
  span {
    word-break: break-word;
  }
  
  .van-icon {
    flex-shrink: 0;
    margin-top: 0.15rem;
  }
}

.cinema-distance {
  flex-shrink: 0;
  font-size: 0.85rem;
  color: #ee0a24;
  font-weight: 500;
  white-space: nowrap;
}

/* 场次信息 */
.showtime-row {
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  padding-top: 0.6rem;
  border-top: 1px dashed #f0f0f0;
  
  .van-icon {
    flex-shrink: 0;
    margin-top: 0.2rem;
  }
}

.showtime-list {
  flex: 1;
  font-size: 0.85rem;
  color: #ee0a24;
  line-height: 1.6;
  word-break: break-word;
}

/* 底部提示文字 */
.finished-text {
  text-align: center;
  padding: 1rem;
  color: #969799;
  font-size: 0.85rem;
}
</style>